import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export const HeaderSort = ({ tableData, clmName, sortParams, sortDataUp, sortDataDown }) => {
	const buttonColor = sortParams?.currentSortClms?.includes(clmName) ? "primary" : "default";

	if (sortParams?.[clmName] === "up") {
		return (
			<IconButton color={buttonColor} onClick={() => sortDataUp(tableData, clmName)} sx={{ padding: "4px" }}>
				<ArrowUpward sx={{ fontSize: "16px" }} />
			</IconButton>
		);
	} else if (sortParams?.[clmName] === "down") {
		return (
			<IconButton color={buttonColor} onClick={() => sortDataDown(tableData, clmName)} sx={{ padding: "4px" }}>
				<ArrowDownward sx={{ fontSize: "16px" }} />
			</IconButton>
		);
	}

	return null;
};
